import React from "react";
import ErrorBoundary from "../../error-boundary";
import DateTime from "../../general-components/date-time/date-time";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import appearancesInPast from "@default/lib/appearances-in-past";
import classNames from "classnames";
import { toMs } from "@default/lib/date-time-helper";

const DateWrapper = ({
  content,
  viewMode,
  showEndDate,
  className,
  showTBA = true,
}) => {
  const releaseState = useSelector(
    (reduxStore) => reduxStore.appStore.releaseState
  );
  const currentLanguage = useSelector(
    (reduxStore) => reduxStore.i18n.currentLanguage
  );

  const dateValue =
    content?.fieldDateRawField?.first?.value &&
    content?.fieldDateRawField?.first;

  const date = {
    value: dateValue?.value,
    endValue: showEndDate && dateValue?.endValue,
  };

  const isElphi = content?.fieldVenueLocation?.label === "Elbphilharmonie";

  if (
    !(
      dateValue?.value &&
      (releaseState.showDay ||
        releaseState.showDate ||
        isElphi ||
        appearancesInPast(content))
    )
  ) {
    return false;
  }

  return (
    <ErrorBoundary>
      <div className={classNames("date-wrapper", { [className]: className })}>
        {(releaseState.showDay || releaseState.showDate || isElphi) &&
          viewMode !== "time" && (
            <div
              className={classNames("day", {
                "make-headline-light": !releaseState.showDate,
              })}
            >
              <DateTime
                value={toMs(date.value)}
                showEnd={false}
                granularity="date"
                mode={releaseState.showDate ? "weekday_short" : "weekday_long"}
              />
            </div>
          )}
        {/* Dates are set as 12:00AM when the days are known, but no times are set. IF this happens, there should no time be visible. */}
        {(releaseState.showDate && content.fieldPlanned) ||
        appearancesInPast(content) ? (
          <div className="time d-flex flex-wrap">
            <DateTime
              value={toMs(date.value)}
              endValue={date.endValue ? toMs(date.endValue) : null}
              showEnd={!!date.endValue}
              granularity="time"
              mode="event_time"
            />
            {currentLanguage !== "en" && (
              <div className="time-suffix">
                <FormattedMessage id={"time.suffix"} />
              </div>
            )}
          </div>
        ) : (
          <>
            {showTBA && (
              <div className="time d-flex flex-wrap">
                <FormattedMessage id={"overview.time"} />: TBA
              </div>
            )}
          </>
        )}
      </div>
    </ErrorBoundary>
  );
};

export default DateWrapper;
